import {HolyOrdersSacramentSvg} from "../../../../components/Svgs/HolyOrdersSacramentSvg";
import React from "react";
import {BaptismSacramentSvg} from "../../../../components/Svgs/BaptismSacramentSvg";
import {FirstCommunionSacramentSvg} from "../../../../components/Svgs/FirstCommunionSacramentSvg";
import {ConfirmationSacramentSvg} from "../../../../components/Svgs/ConfirmationSacramentSvg";
import {MatrimonySacramentSvg} from "../../../../components/Svgs/MatrimonySacramentSvg";
import {AnointingOfTheSickSacramentSvg} from "../../../../components/Svgs/AnointingOfTheSickSacramentSvg";

export const SacramentTypes = [
    {
        value: 'baptism',
        label: 'sacrament of baptism',
        icon: <BaptismSacramentSvg/>,
        description: 'baptism_description',
    },
    {
        value: 'first_communion',
        label: 'first communion',
        icon: <FirstCommunionSacramentSvg/>,
        description: 'first_communion_description',
    },
    {
        value: 'confirmation',
        label: 'sacrament of confirmation',
        icon: <ConfirmationSacramentSvg/>,
        description: 'confirmation_description',
    },
    {
        value: 'matrimony',
        label: 'sacrament of matrimony',
        icon: <MatrimonySacramentSvg/>,
        description: 'matrimony_description',
    },
    {
        value: 'holy_orders',
        label: 'sacrament of holy orders',
        icon: <HolyOrdersSacramentSvg/>,
        description: 'holy_orders_description',
    },
    {
        value: 'anointing_of_the_sick',
        label: 'sacrament of anointing of the sick',
        icon: <AnointingOfTheSickSacramentSvg />,
        description: 'anointing_of_the_sick_description',
    },
]